var Component = require('./../../Component');
var normal_template = require('./../../../template/group-member-panel.html');
var authority_template = require('./../../../template/group-authority-panel.html');
var Scrollbar = require('./../../Scrollbar');

var Panel = function (options) {
  (function (self) {
    var defaults = {
      template: options.is_authority ? authority_template : normal_template,
      member_avatar: '<div class="panel-unit"><div class="panel-circle panel-avatar"><img src="{$avatar_src}"></div><div class="panel-label">{$name}</div></div>',
      member_add: '<div class="panel-unit"><div class="panel-circle panel-add"></div></div>',
      member_delete: '<div class="panel-unit"><div class="panel-circle panel-delete"></div></div>',
      more_members: '<div class="more-members"></div>',
      pageIndex: 0,
      perPage: 20
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);

  (function (self) {
    var scrollbar = new Scrollbar({
      window: self._element.find('.im-panel-members'),
      content: self._element.find('.panel-members')
    });

    self._element.append(scrollbar.getElement());
    self._children['flat-window-scrollbar'] = scrollbar;

    setTimeout(function () {
      scrollbar.init();
    }, 0);

    scrollbar.addEventListener("scrolled", function (scrolltop) {
      var wrapHeight = self.getElement().find('.im-panel-members').height();
      var listHeight = self.getElement().find('.panel-members').height();
      if (listHeight < wrapHeight) {
        return false;
      }
      if (listHeight - wrapHeight - scrolltop <= 5) {
        if (self._options.hasMore) self.render();
      }
    });

  })(this);

  (function (self) {
    var nick_edit = false;
    var nick_edit_btn = self._element.find('.js-group-nick.edit-btn');
    var nick_ensure_btn = self._element.find('.js-group-nick.ensure-btn');
    var nick_input = self._element.find('input.js-group-nick');
    var name_edit = false;
    var name_edit_btn = self._element.find('.js-group-name.edit-btn');
    var name_ensure_btn = self._element.find('.js-group-name.ensure-btn');
    var name_input = self._element.find('input.js-group-name');
    var notice_edit = false;
    var notice_edit_btn = self._element.find('.js-group-notice.edit-btn');
    var notice_ensure_btn = self._element.find('.js-group-notice.ensure-btn');
    var notice_input = self._element.find('input.js-group-notice');
    var quit_group_btn = self._element.find('.panel-button');
    var disband_group_btn = self._element.find('.panel-disband-button');
    var group_qrcode = self._element.find('.js-group-qrcode');
    var add_member_btn = self._element.find('.member-btn.js-add-member');
    var delete_member_btn = self._element.find('.member-btn.js-delete-member');
    self._options.doms = {
      nick_edit_btn: nick_edit_btn,
      nick_ensure_btn: nick_ensure_btn,
      nick_input: nick_input,
      name_edit_btn: name_edit_btn,
      name_ensure_btn: name_ensure_btn,
      name_input: name_input,
      notice_edit_btn: notice_edit_btn,
      notice_ensure_btn: notice_ensure_btn,
      notice_input: notice_input
    };
    self._options.nick_loading = false;
    self._options.name_loading = false;
    self._options.notice_loading = false;
    name_edit_btn.click(function (e) {
      if (name_edit || self._options.name_loading) return;
      name_edit_btn.removeClass('hower-show').hide();
      name_ensure_btn.addClass('showed');
      name_input.attr('disabled', false);
      name_edit = true;
    });
    name_ensure_btn.click(function (e) {
      var val = name_input.val();
      // if (!name_edit || self._options.name_loading || !val) return;
      if (val.length > 40) return;
      self._options.name_loading = true;
      var input_val = name_input.val();
      if (input_val.length > 40) return;

      var panel_container = $('body').find(".im-app").find(".im-chatwindow").find(".im-panel-container");
      if (val.length > 0 && val.trim().length == 0) {
        // 输入为空格
        self.resetPanel('group_name', self._data.group_name);
        panel_container.hide();
      } else if (val.length == 0) {
        // 输入为空
        self.resetPanel('group_name', self._data.group_name);
        panel_container.hide();
      } else {
        self.triggerEvent('updateGroupName', {
          group_name: val,
          old_group_name: self._data.group_name
        });
      }
      name_edit = false;
      self._opened = false;
    });
    nick_edit_btn.click(function (e) {
      if (nick_edit || self._options.nick_loading) return;
      nick_edit_btn.removeClass('hower-show').hide();
      nick_ensure_btn.addClass('showed');
      nick_input.attr('disabled', false);
      nick_edit = true;
    });
    nick_ensure_btn.click(function (e) {
      var val = nick_input.val();
      if (!nick_edit || self._options.nick_loading) return;
      self._options.nick_loading = true;
      self.triggerEvent('updateNickName', {
        nick_name: val || '',
        old_nick_name: self._data.nick_name,
        id: self._data.user_id,
        source: self._data.user_source
      });
      nick_edit = false;
      self._opened = false;
    });
    notice_edit_btn.click(function (e) {
      if (notice_edit || self._options.notice_loading) return;
      notice_edit_btn.removeClass('hower-show').hide();
      notice_ensure_btn.addClass('showed');
      notice_input.attr('disabled', false);
      notice_edit = true;
    });
    notice_ensure_btn.click(function (e) {
      var val = notice_input.val();
      // if (!notice_edit || self._options.notice_loading || !val) return;
      self._options.notice_loading = true;
      var input_val = notice_input.val();
      if (input_val.length > 2000) return;
      var panel_container = $('body').find(".im-app").find(".im-chatwindow").find(".im-panel-container");
      if (input_val.length > 0 && input_val.trim().length == 0) {
        // 输入为空格
        self.resetPanel('group_notice', self._data.group_notice);
        panel_container.hide();
      // } else if (input_val.length == 0) {
      //   // 输入为空
      //   self.resetPanel('group_notice', self._data.group_notice);
      //   panel_container.hide();
      } 
      else {
        self.triggerEvent('groupNotice', {
          group_notice: input_val,
          old_group_notice: self._options.group_notice
        });
      }
      notice_edit = false;
      self._opened = false;
    });
    add_member_btn.click(function () {
      self.triggerEvent('addMember', {
        contacts: self._data.contacts
      });
    });
    if (self._options.is_authority) delete_member_btn.click(function () {
      self.triggerEvent('deleteMember', {
        contacts: self._data.contacts,
        id_sources: self._data.id_sources
      });
    });
    group_qrcode.click(function () {
      self.triggerEvent('getGroupQrCode');
    });
    quit_group_btn.click(function () {
      self.triggerEvent('quitGroup');
    });
    disband_group_btn.click(function () {
      self.triggerEvent('disbandGroup');
    });
    self._element.on('click', function (e) {
      e.stopPropagation();
    });
  })(this);
};
Panel.prototype = Object.create(Component.prototype);
Panel.prototype.render = function () {
  var contacts = this._data.contacts;
  var id_sources = this._data.id_sources;
  var membersHtml = '';
  var count = 0;
  for (var index = this._options.pageIndex * this._options.perPage; index < id_sources.length; index++) {
    if (contacts && contacts[id_sources[index]]) {
      membersHtml += this._options.member_avatar.replace('{$avatar_src}', contacts[id_sources[index]].avatar).replace('{$name}', contacts[id_sources[index]].remark_name || contacts[id_sources[index]].nick_name || contacts[id_sources[index]].user_name);
      count += 1;
    }
    if (count >= this._options.perPage) break;
  }
  if (this._options.pageIndex == 0) {
    this._element.find('.panel-members').html(membersHtml);
  } else {
    this._element.find('.panel-members').append(membersHtml);
  }
  if (this._options.pageIndex * this._options.perPage + count < id_sources.length) {
    this._options.pageIndex += 1;
    this._options.hasMore = true;
  } else {
    this._options.hasMore = false;
  }
};
Panel.prototype.setValue = function () {
  this._options.pageIndex = 0;
  var id_source = this._data.user_id + '@' + this._data.user_source;
  var me = this._data.contacts[id_source];
  if (this._options.is_authority) {
    this._element.find('.js-group-notice').val(this._data.group_notice);
  }
  this._element.find('.js-group-name').val(this._data.group_name);
  var meKey = me.user_id + '@' + me.user_source;
  var meContact = this._data.contacts[meKey];
  if (meContact && meContact.nick_name) {
    this._data.nick_name = meContact.nick_name;
    this._element.find('.js-group-nick').val(meContact.nick_name);
  }
};
Panel.prototype.resetPanel = function (type, value) {
  var doms = this._options.doms;
  switch (type) {
    case 'nick_name':
      doms.nick_ensure_btn.removeClass('showed');
      doms.nick_edit_btn.addClass('hower-show').show();
      doms.nick_input.val(value);
      doms.nick_input.attr('disabled', true);
      this._options.nick_loading = false;
      break;
    case 'group_name':
      doms.name_ensure_btn.removeClass('showed');
      doms.name_edit_btn.addClass('hower-show').show();
      doms.name_input.val(value);
      doms.name_input.attr('disabled', true);
      this._options.name_loading = false;
      break;
    case 'group_notice':
      doms.notice_ensure_btn.removeClass('showed');
      doms.notice_edit_btn.addClass('hower-show').show();
      doms.notice_input.val(value);
      doms.notice_input.attr('disabled', true);
      this._options.notice_loading = false;
      break;
    default:
      break;
  }
};
Panel.prototype.open = function () {
  this._opened = true;
  this._element.addClass('im-opened');
};
Panel.prototype.close = function () {
  this._opened = false;
  this._element.removeClass('im-opened');
};
Panel.prototype.toggle = function () {
  if (this._opened) {
    this.close();
  } else {
    this.open();
  }
};
module.exports = Panel;
